import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "utilityVanSmallFilled"
const UtilityVanSmallFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 15C7.036 15 7.875 15.84 7.875 16.875S7.035 18.75 6 18.75 4.125 17.91 4.125 16.875 4.965 15 6 15M17.625 15C18.66 15 19.5 15.84 19.5 16.875S18.66 18.75 17.625 18.75 15.75 17.91 15.75 16.875 16.59 15 17.625 15" />
          <path
            fillRule="evenodd"
            d="M15.697 7.313C16.387 7.313 17.031 7.657 17.413 8.23L19.121 10.792 20.456 11.327C20.868 11.492 21.17 11.853 21.257 12.287L21.5 13.5H21.375C21.065 13.5 20.813 13.752 20.813 14.063S21.064 14.625 21.375 14.625H21.563V16.125C21.563 16.85 20.975 17.438 20.25 17.438H20.189Q20.249 17.165 20.25 16.875C20.25 15.425 19.075 14.25 17.625 14.25S15 15.425 15 16.875Q15.001 17.165 15.062 17.438H8.563Q8.624 17.165 8.625 16.875C8.625 15.425 7.45 14.25 6 14.25S3.375 15.425 3.375 16.875Q3.376 17.165 3.437 17.438H3.375C2.65 17.438 2.063 16.85 2.063 16.125V14.625H2.625C2.935 14.625 3.188 14.373 3.188 14.063S2.936 13.5 2.625 13.5H2.063V11.901L2.096 11.808 3.416 8.177C3.607 7.658 4.099 7.313 4.65 7.313zM15.277 10.59C15.312 10.65 15.375 10.688 15.443 10.688H17.699L16.477 8.855C16.303 8.595 16.011 8.438 15.697 8.437H14.081z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UtilityVanSmallFilledIcon
